import { makeAutoObservable } from 'mobx';
import { RestorePasswordManager } from '../../../../core-logic/modules/authorization/managers/RestorePasswordManager';

class RestorePasswordUIManager {
  constructor(private restoreManager: RestorePasswordManager) {
    makeAutoObservable(this, {});
  }

  get coreManager() {
    return this.restoreManager;
  }
}

export { RestorePasswordUIManager };
